import { render } from "./Energy.vue?vue&type=template&id=f534e1ee&scoped=true"
import script from "./Energy.vue?vue&type=script&lang=js"
export * from "./Energy.vue?vue&type=script&lang=js"

import "./Energy.vue?vue&type=style&index=0&id=f534e1ee&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f534e1ee"]])

export default __exports__